<div class="content">
    <section>
        <h2>NEUIGKEITEN</h2>
        <p>Auf unserer Webseite gibt es immer wieder spannende Neuigkeiten zu entdecken. Ob neue Aktivitäten, interessante Veranstaltungen oder wichtige Ankündigungen - wir halten Dich stets auf dem Laufenden. Besuche uns regelmäßig, um keine Neuigkeiten zu verpassen.</p>
        <app-news-builder></app-news-builder>
    </section>
</div>